const InfoEntreprise = (data) => {
  return (dispatch) => dispatch({ type: "GET_INFO", payload: data });
};
export default InfoEntreprise;
